import classNames from 'classnames';

import styles from './ColoredDot.module.css';

type ColoredDotProps = {
    size?: 'small' | 'medium' | 'large' | 'xlarge';
    className?: string;
} & (
    | {
          variant?:
              | 'default'
              | 'brand'
              | 'success'
              | 'warning'
              | 'error'
              | 'dimmed';
          hex?: never;
      }
    | {
          variant: 'custom';
          hex: string;
      }
);

const ColoredDot = ({
    variant = 'default',
    size = 'medium',
    className,
    hex,
}: ColoredDotProps) => {
    return (
        <span
            className={classNames(className, styles.Root, {
                [styles.default]: variant === 'default',
                [styles.brand]: variant === 'brand',
                [styles.success]: variant === 'success',
                [styles.warning]: variant === 'warning',
                [styles.error]: variant === 'error',
                [styles.dimmed]: variant === 'dimmed',
                [styles.small]: size === 'small',
                [styles.medium]: size === 'medium',
                [styles.large]: size === 'large',
                [styles.xlarge]: size === 'xlarge',
            })}
            style={
                variant === 'custom'
                    ? {
                          backgroundColor: hex,
                      }
                    : undefined
            }
        />
    );
};

export default ColoredDot;
